import React from "react";
import {
  Box,
  Paper,
  Typography,
  Stack,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import Grid from "@mui/material/Grid2";

import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";

import { CRITERIOS_CONTINGENCIAS, DEFAULT_ITEMS_CONTINGENCIAS } from "../../Constants/Constants";

export default function ContingenciasSelection({
  items = CRITERIOS_CONTINGENCIAS,
  onSelect,
  showListLink = true,
}) {
  const navigate = useNavigate();

  const seleccionar = (criterio) => {
    const tipo = DEFAULT_ITEMS_CONTINGENCIAS.find((item) => item.id === criterio.tipoId);
    if (!tipo) return;
    onSelect?.({
      id: tipo.id,
      type: tipo.type,
      subtype: tipo.subtype,
      title: tipo.title,
      description: tipo.description,
      codigo: criterio.codigo,
    });
  };

  return (
    <PageBgBlock pad="2rem 2rem">
        <Stack spacing={2} alignItems="center" sx={{ textAlign: "center" }}>
          <Typography
                  variant="h1"
                  align="center"
                  sx={{ marginBottom: "0.24rem" }}
                >
            CREACIÓN DE JUSTIFICACIÓN DE INDISPONIBILIDAD
          </Typography>

          <Typography variant="body1" sx={{ maxWidth: 900, color: "text.secondary", pb: 1 }}>
            Esta sección de creación de Justificación de Indisponibilidad  le permite reportar y justificar interrupciones o problemas de conectividad no atribuibles a su gestión. Seleccione la categoría de justificación de indisponibilidad que mejor describa la situación presentada.
          </Typography>

          <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, width: "100%", maxWidth: 1200 }}>
            {items.map((criterio) => (
              <Grid key={criterio.codigo} size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2.5,
                    height: "100%",
                    borderRadius: 3,
                    background: "#BBDEFB",
                  }}
                >
                  <Stack spacing={2} sx={{ height: "100%" }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", px: 2, fontWeight: "bold" }}
                    >
                      {criterio.title}
                    </Typography>

                    <Box>
                      <PageButtonBlack width="100%" onClick={() => seleccionar(criterio)}>
                        Crear justificación
                      </PageButtonBlack>
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {showListLink && (
            <>
              <Typography variant="body1" sx={{ color: "text.secondary", pt: 3  }}>
                Si quiere revisar el listado de Justificaciones de Indisponibilidad ya creadas puede ingresar a través del
                menú, ir a Justificaciones de Indisponibilidad y seleccionar ‘Ver listado’ o puede ingresar en el siguiente enlace
              </Typography>
              <PageButtonSimple onClick={() => navigate("/contingencias_lista")}>
                  Ir al listado de justificaciones de indisponibilidad
                </PageButtonSimple>
            </>
          )}
        </Stack>
    </PageBgBlock>
  );
}
